 import Component from '../abstracts/Component';
 // quick refactoring of privacyComponent
 export default class PrivacyUnsubscribe extends Component {
 
   static get SELECTORS() {
     return {

     };
   }
 
   initFormUnsubscribe() {
     let ctx = this;
     
     ctx.showButtonApply();
     
     $('body').on('click.fu', '.js-apply-subscriptions-options', function(e) {
       e.preventDefault();
       var err = true;
 
       $.each($('#updatePrivacyForm .privacy-list'), function(index, el) {
         var currNL_el = $(this).find("input[name='currentProfiling["+index+"].newsletter']")[0];
         var currPR_el = $(this).find("input[name='currentProfiling["+index+"].profiled']")[0];
 
         if ( currNL_el.checked || currPR_el.checked ) {
           err = false;
           return false;
         }
         });
 
       $('.js-apply-subscriptions-options').prop('disabled', true);
       $('#updatePrivacyForm').submit();
       return true;
 
     });
   }
   
   optionNewsletter() {
    
      let ctx = this;
      
      $('#updatePrivacyForm .privacy-list .second-condition input').click(function () {
        var secondCondition = $(this).closest('.second-condition');
        const conditions = $(this).closest('.conditions');

        
        if($(this).attr('value') == 'false'){
          $(this).addClass('active');
          conditions.find('.show-select').addClass('d-block');
          conditions.find('select').addClass('active');
        }
        else {
          secondCondition.find('input').removeClass('active');
          conditions.find('select').removeClass('active');
          conditions.find('select')[0].value = '';
          conditions.find('select').attr('value', '');
          conditions.find('.select2-selection__rendered').text(conditions.find('select option')[0].text);
          conditions.find('textarea')[0].value = '';
          conditions.find('textarea').attr('value', '');
          conditions.find('.show-select').removeClass('d-block');
          conditions.find('.form-textarea').removeClass('d-block');
        }
        
        ctx.showButtonApply();
      });
      
      ctx.showSelect(ctx);
      
   }
   
   showSelect(ctx) {
	   this.$on('change', ({event}) => {
	        
		   $.each($('#updatePrivacyForm .privacy-list'), function() {
	          
			   var _this = $(this);
			   var dropdownMobile = _this.find('.select2-hidden-accessible').length == 0 ? true : false;
			   var textSelect2 = dropdownMobile ? _this.find('select')[0].value : _this.find('.select2-selection__rendered')[0].innerHTML;
			   var dropdownElementLength = dropdownMobile ? _this.find('select')[0].length : _this.find('.select2-hidden-accessible')[0].length;
			      
	           for(var i = 1; i < dropdownElementLength; i++) {
	             var textSelect = dropdownMobile ? _this.find('select')[0][i].value : _this.find('.select2-hidden-accessible')[0][i].innerHTML;
	             if (textSelect2 == textSelect) {
				   var valueSelect = dropdownMobile ? textSelect : _this.find('.select2-hidden-accessible')[0][i].value;
				   _this.find('select')[0].value = valueSelect;
				   _this.find('select').attr('value', valueSelect);
				 }
			   }
	      
	           if(_this.find('select').attr('value') == 'UNS_5') {
	        	   _this.find('.form-textarea').addClass('d-block');   
	           }
	           else {
	        	   _this.find('textarea')[0].value = '';
	               _this.find('textarea').attr('value', '');
	           }
	          
			   if(_this.find('select').attr('value') != 'UNS_5') {
				   _this.find('.form-textarea').removeClass('d-block');    
			   }
	        });
	        
	        ctx.showButtonApply();
	   });
   }
  
   selectFreeText() {
    
	   let ctx = this;
    
	   $('#updatePrivacyForm .form-textarea textarea').keyup(function () {
  
		   if ($(this)[0].value != '') {
			   $(this).attr('value', $(this)[0].value);  
		   }
      
		   ctx.showButtonApply();
	   });
   }
  
   showButtonApply() {
    
    var count = 0;
    
    $.each($('#updatePrivacyForm .privacy-list'), function(index, el) {
      
      var _this = $(this);
      
      var selectValue = _this.find('select')[0].value;
      
      var freeTextValue = _this.find('textarea')[0].value == '';
      
      var secondCondition = _this.find('.second-condition input');
      
      if(_this.find('select').hasClass('active') && (selectValue == '' || (selectValue == 'UNS_5' && freeTextValue))) {
        count += 1;
        $('.js-apply-subscriptions-options').prop('disabled', true);
      }
      
      if (selectValue == '') {
    	  _this.find('select').removeAttr('name');
      }
      else {
    	  _this.find('select').attr('name', 'currentProfiling['+index+'].reason');
      }
      
      if(secondCondition.hasClass('active')) {
    	  _this.find('textarea').attr('name', 'currentProfiling['+index+'].freeText');
      }
      else {
    	  _this.find('textarea').removeAttr('name');
      }
      
    });
    
    if (count == 0) {
      $('.js-apply-subscriptions-options').prop('disabled', false);
    }
   }

 
   render() {
 
     $('body').on("click.pok",".my-account-unsubscribe-modal .privacy-ok", function(){
       $("<input type='hidden' name='delete-profile' value='delete-profile'/>").appendTo('#updatePrivacyForm');
       $("#updatePrivacyForm, #recallForm").submit();
       $(".vex-close").click();
     });
 
     $('body').on("click.pko",".my-account-unsubscribe-modal .privacy-ko", function(){
       $(".vex-close").click();
     });
     
     if($('body').data('template') === 't-optout' || $('body').data('template') === 't-myaccount-unsubscribeNL') {
    	 this.initFormUnsubscribe();
    	 this.optionNewsletter();
    	 this.selectFreeText();
     }
   }
 }